import { opacity } from '../../utils';
import { grayPalette } from '../../themes/colors';

export const drawerLightThemeV2 = {
  backgroundColor: grayPalette[0],
  shadow: opacity(grayPalette[400], 20),
};
